import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Imoveis from "@/pages/Imoveis";
import ImovelDetalhe from "@/pages/ImovelDetalhe";
import Sobre from "@/pages/Sobre";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import PropertyForm from "@/pages/admin/PropertyForm";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <SiteProvider>
            <BrowserRouter>
              <Routes>
                <Route element={<Layout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/imoveis" element={<Imoveis />} />
                  <Route path="/imoveis/:id" element={<ImovelDetalhe />} />
                  <Route path="/sobre" element={<Sobre />} />
                </Route>
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/imoveis/novo" element={<PropertyForm />} />
                <Route path="/admin/imoveis/:id/editar" element={<PropertyForm />} />
              </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
          </SiteProvider>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
